$(document).ready(function () {
  let initiated = '';

  if (window.innerWidth > 768) {
    initiated = true;
  } else {
    initiated = false;
  }

  const carouselOptions = () => {
    $('.project-subscription-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-subscription-nav',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
          },
        },
      ],
    });

    $('.slider-subscription-nav').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.project-subscription-carousel',
      dots: false,
      arrows: false,
      centerMode: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 6,
          },
        },
      ],
    });
  };

  if (initiated) {
    carouselOptions();
  } else {
    $('#projectInformationButton').on('click', function () {
      carouselOptions();
    });
    initiated = true;
  }
});
